import TextField from '@material-ui/core/TextField';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/form';

interface Props {
  name: string;
  label: string;
  autoFocus?: boolean;
  disabled?: boolean;
  className?: string;
  initialValue?: string | number;
}

/**
 * Controlled text input that uses react-hook-form's Controller wrapping a TextField
 * @param props Props for the input
 */
export const TextInput: FC<Props> = (props: Props) => {
  const {name, disabled, initialValue, label, autoFocus, className} = props;

  const formContext = useFormContext();
  const {control} = formContext;
  const errors: FieldErrors = formContext.errors;

  const renderInput = (renderInputProps: any) =>
    (
      <TextField
        {...renderInputProps}
        id={name}
        disabled={disabled}
        label={label}
        autoFocus={autoFocus}
        className={className}
        autoComplete="off"
        fullWidth={true}
        error={!!errors[name]}
        helperText={errors[name] ? errors[name].message : ''}
      />
    );

  return (
    <Controller
      name={name}
      defaultValue={initialValue}
      control={control}
      render={renderInput}
    />
  );
};
